export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    /** Tiers are disabled */
    Status["DISABLED"] = "DISABLED";
    /** Tiers are enabled but not yet active */
    Status["DRAFT"] = "DRAFT";
    /** Tiers are active */
    Status["ACTIVE"] = "ACTIVE";
    /** Tiers are paused */
    Status["PAUSED"] = "PAUSED";
})(Status || (Status = {}));
//# sourceMappingURL=types.impl.js.map